import { render, staticRenderFns } from "./RemoveRoleModal.vue?vue&type=template&id=b5c368cc&scoped=true"
import script from "./RemoveRoleModal.vue?vue&type=script&lang=js"
export * from "./RemoveRoleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c368cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5c368cc')) {
      api.createRecord('b5c368cc', component.options)
    } else {
      api.reload('b5c368cc', component.options)
    }
    module.hot.accept("./RemoveRoleModal.vue?vue&type=template&id=b5c368cc&scoped=true", function () {
      api.rerender('b5c368cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/Roles/RemoveRoleModal.vue"
export default component.exports